import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import { AiFillEye } from "react-icons/ai";
import { BsFillEyeSlashFill } from "react-icons/bs";
import { useGetUsersQuery, useSignUpUserMutation, useUpdateUserMutation } from '../../store/api/userAuthApi';
import DataTable from 'react-data-table-component';
import { FaRegEdit } from 'react-icons/fa';
const initialUsers = {
    name: '',
    phone: '',
    username: '',
    password: '',
}

const initialUpdateUsers = {
    id: 0,
    name: '',
    username: '',
    phone: '',
    password: "",
}

export default function Settings() {
    const [user, setUsers] = useState(initialUsers)
    const [searchTerm, setSearchTerm] = useState('');
    const [SignUpUser] = useSignUpUserMutation();
    const [updateExistUser] = useUpdateUserMutation();
    const [showPassword, setShowPassword] = useState(false);
    const [updateUsers, setUpdate] = useState(initialUpdateUsers)
    // All Exist Users
    const [dataUsers, setUsersData] = useState([]);
    // Fetch Users
    const { data, error, isLoading } = useGetUsersQuery();
    useEffect(() => {
        if (data && Array.isArray(data)) {
            setUsersData(data)
        }
    }, [data]);


    const [page, setPage] = useState(1) // by default is 1
    const [perPage, setPerPage] = useState(3)


    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };


    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
                <div className="color-text fs-4">Loading...</div>
            </div>
        )
    }

    if (error) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
                <div className="row">
                    <div className="col-12 opacity-75 bg-light p-4 rounded-3 shadow-md border w-100">
                        <h3 className="text-danger">Opps!!!</h3>
                        <span className="fs-4">
                            A <span className="text-danger fw-bold ">{error.message}</span> has occurred{' '}
                        </span>
                        <div className="fs-5"> The server is shut down 😢</div>
                    </div>
                </div>
            </div>
        )
    }



    // // Filter data based on search term
    const filteredData = dataUsers.filter((item) =>
        Object.values(item).some((value) =>
            value.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
    );


    const handleUpdate = (updateData) => {

        setUpdate({
            id: updateData.id,
            name: updateData.name,
            username: updateData.username,
            phone: updateData.phone,
            password: null
        })
    }
  








    // Save Data User
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await SignUpUser(user);
            if (response.data.status === 200) {
                Swal.fire({
                    title: 'Success!',
                    text: response.data.message,
                    icon: 'success',
                    confirmButtonText: 'Done'
                })
            } else {
                Swal.fire({
                    title: 'error!',
                    text: response.data.message,
                    icon: 'error',
                    confirmButtonText: 'Close'
                });
            }
            setUsers(initialUsers)
        } catch (error) {

            console.log(error);
        }
    };


    // Update Data User
    const handleSubmitUpdate = async (e) => {
        e.preventDefault();

        try {
            const response = await updateExistUser(updateUsers);
            if (response.data.status === 200) {
                Swal.fire({
                    title: 'Success!',
                    text: response.data.message,
                    icon: 'success',
                    confirmButtonText: 'Done'
                })
            } else {
                Swal.fire({
                    title: 'error!',
                    text: response.data.message,
                    icon: 'error',
                    confirmButtonText: 'Close'
                });
            }
            setUpdate(initialUpdateUsers)
        } catch (error) {

            console.log(error);
        }
    };



    const _columns = [
        { name: 'Id', selector: (row) => row.id, sortable: true, center: true },

        {
            name: 'Name',
            selector: (row) => row.name,
            sortable: true,
            center: true
        },
        {
            name: 'username',
            selector: (row) => row.username,
            sortable: true,
            center: true
        },
        {
            name: 'Phone',
            selector: (row) => row.phone,
            sortable: true,
            center: true
        },
        {
            name: 'Create At',
            selector: (row) => row.created,
            sortable: true,
            center: true
        },
        {
            name: 'Updated At',
            selector: (row) => row.updated,
            sortable: true,
            center: true
        },

        {
            name: 'Actions',
            cell: (row) => (
                <>
                    <button
                        style={{ background: '#1a2131' }}
                        className="btn btn-success me-3 border-0  text-white"
                        data-bs-toggle="modal"
                        data-bs-target="#modal-fromleft-update"
                        onClick={() => handleUpdate(row)}
                    >
                        <FaRegEdit />
                    </button>
                </>
            ),
            center: true
        }
    ];


    // changes pages
    const handlePageChange = (page) => {
        setPage(page)
    }

    // change perpage
    const handlePerPageChange = (perPage) => {
        setPerPage(perPage)
    }

    // --> paginatedData
    const paginatedData = filteredData.length
        ? filteredData.slice((page - 1) * perPage, page * perPage)
        : dataUsers.slice((page - 1) * perPage, page * perPage)


    const canSave = [user.name, user.phone, user.username, user.password].every(Boolean)
    const canUpdate = [updateUsers.name, updateUsers.phone, updateUsers.username].every(Boolean)

    return (
        <>
            <div className="block">
                <div className="block-content block-content-full">
                    <div class="row">
                        <button
                            style={{ width: '100px' }}
                            className="btn btn-primary me-3 border-0 btn-md text-white ms-auto"
                            data-bs-toggle="modal"
                            data-bs-target="#modal-fromleft-save"

                        >
                            Add User
                        </button>
                        <div
                            class="modal fade"
                            id="modal-fromleft-save"
                            tabindex="-1"
                            role="dialog"
                            aria-labelledby="modal-fromleft"
                            aria-hidden="true"
                        >
                            <div class="modal-dialog modal-dialog-fromleft" role="document">
                                <div class="modal-content">
                                    <div class="block block-themed block-transparent mb-0">
                                        <div class="block-header1 d-flex p-3 bg-yellows">
                                            <h3 class="block-title text-dark mt-2">Add User</h3>
                                            <div class="block-options">
                                                <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close">
                                                    <h4 className='m-0 p-0'>x</h4>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="block-content">
                                            <form>
                                                <div className="row">
                                                    <div className="col-sm-12 hover">
                                                        <div className="mb-3">
                                                            <div className="row">
                                                                <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                                                                    Name
                                                                </label>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                style={{height: '50px'}}
                                                                className="form-control"
                                                                id="exampleFormControlInput1"
                                                                placeholder="name"
                                                                value={user.name}
                                                                onChange={(e) => setUsers({ ...user, name: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-sm-12 hover">
                                                        <div className="mb-3">
                                                            <div className="row">
                                                                <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                                                                    Phone
                                                                </label>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                style={{height: '50px'}}
                                                                className="form-control"
                                                                id="exampleFormControlInput1"
                                                                placeholder="phone"
                                                                value={user.phone}
                                                                onChange={(e) => setUsers({ ...user, phone: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-12 hover">
                                                        <div className="mb-3">
                                                            <div className="row">
                                                                <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                                                                    username
                                                                </label>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                style={{height: '50px'}}
                                                                className="form-control"
                                                                id="exampleFormControlInput1"
                                                                placeholder="username"
                                                                value={user.username}
                                                                onChange={(e) => setUsers({ ...user, username: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-12">
                                                        <label>Password</label>
                                                        <div class="input-group mb-3">
                                                            <input  style={{height: '50px'}} type={showPassword ? 'text' : 'password'} onChange={(e) => setUsers({ ...user, password: e.target.value })} class="form-control" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                                                            <span class="input-group-text" id="basic-addon2" onClick={handleTogglePassword}> {showPassword ? <AiFillEye className='fs-4' /> : <BsFillEyeSlashFill className='fs-4' />}   </span>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div class="modal-footer">

                                                    <input
                                                        type="submit"
                                                        style={{height: '40px'}}
                                                        class="btn btn-primary "
                                                        data-bs-dismiss="modal"
                                                        onClick={handleSubmit}
                                                        disabled={!canSave}
                                                        value="Save changes"
                                                    />
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='block-content1 p-5 pt-0'>
                <div className="row">
                    <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                        Search User
                    </label>

                    <input
                        style={{height: '50px'}}
                        type="text"
                        className="form-control"
                        id="exampleFormControlInput1"
                        placeholder="search users"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />

                </div>



                <div className="row  mt-4">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xl-12 col-12">
                        <DataTable
                            pointerOnHover
                            className="rounded-3 "
                            columns={_columns}
                            data={paginatedData}

                            striped
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={dataUsers.length}
                            paginationPerPage={perPage}
                            paginationRowsPerPageOptions={[1, 25, 50]}
                            onChangePage={handlePageChange}
                            onChangeRowsPerPage={handlePerPageChange}
                        />
                    </div>
                    <div className="row ">

                    </div>
                </div>


            </div>


            <div
                class="modal fade"
                id="modal-fromleft-update"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-fromleft"
                aria-hidden="true"
            >
                <div class="modal-dialog modal-dialog-fromleft" role="document">
                    <div class="modal-content">
                        <div class="block block-themed block-transparent mb-0">
                            <div class="block-header1 d-flex p-3 bg-yellows">
                                <h3 class="block-title text-dark mt-2">Edit User</h3>
                                <div class="block-options">
                                    <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close">
                                    <h4 className='m-0 p-0'>x</h4>
                                    </button>
                                </div>
                            </div>
                            <div class="block-content">
                                <form encType="multipart/form-data">
                                    <div className="row">
                                        <div className="col-sm-12 hover">
                                            <div className="mb-3">
                                                <div className="row">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                                                        Name
                                                    </label>
                                                </div>
                                                <input
                                                    type="text"
                                                    style={{height: '50px'}}
                                                    className="form-control"
                                                    id="exampleFormControlInput1"
                                                    placeholder="name"
                                                    value={updateUsers.name}
                                                    onChange={(e) => setUpdate({ ...updateUsers, name: e.target.value })}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-sm-12 hover">
                                            <div className="mb-3">
                                                <div className="row">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                                                        Phone
                                                    </label>
                                                </div>
                                                <input
                                                    type="text"
                                                    style={{height: '50px'}}
                                                    className="form-control"
                                                    id="exampleFormControlInput1"
                                                    placeholder="phone"
                                                    value={updateUsers.phone}
                                                    onChange={(e) => setUpdate({ ...updateUsers, phone: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 hover">
                                            <div className="mb-3">
                                                <div className="row">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                                                        username
                                                    </label>
                                                </div>
                                                <input
                                                    type="text"
                                                    style={{height: '50px'}}
                                                    className="form-control"
                                                    id="exampleFormControlInput1"
                                                    placeholder="username"
                                                    value={updateUsers.username}
                                                    onChange={(e) => setUpdate({ ...updateUsers, username: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-12">
                                            <label>Password</label>
                                            <div class="input-group mb-3">
                                                <input  style={{height: '50px'}} value={updateUsers.password} type={showPassword ? 'text' : 'password'} onChange={(e) => setUpdate({ ...updateUsers, password: e.target.value === "" ? "" : e.target.value })} class="form-control" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                                                <span class="input-group-text" id="basic-addon2" onClick={handleTogglePassword}> {showPassword ? <AiFillEye className='fs-4' /> : <BsFillEyeSlashFill className='fs-4' />}   </span>
                                            </div>
                                        </div>
                                        {/* <div className="col-sm-6">
                                            <label>Password</label>
                                            <div class="input-group mb-3">
                                                <input type='text' value={updateUsers} onChange={(e) => setUpdate({ ...updateUsers, password: e.target.value })} class="form-control" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                                            </div>
                                        </div> */}

                                    </div>

                                    <div class="modal-footer">
                                        <button type="submit" style={{height: '40px'}}  class="btn btn-secondary" data-bs-dismiss="modal">
                                            Close
                                        </button>
                                        <input
                                            type="submit"
                                            style={{height: '40px'}}
                                            class="btn btn-primary "
                                            data-bs-dismiss="modal"
                                            onClick={handleSubmitUpdate}
                                            disabled={!canUpdate}
                                            value="Save changes"
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
